import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service here
    console.error("Caught by Error Boundary:", error, errorInfo);
    this.setState({ errorInfo: error });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#fff3e0', border: '1px solid #ffcc80', borderRadius: 2 }}>
            <WarningAmberIcon color="warning" sx={{ fontSize: 40 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
                Something went wrong loading this component.
            </Typography>
            <Button variant="outlined" color="warning" onClick={() => window.location.reload()}>
                Reload Page
            </Button>
        </Box>
      );
    }
    return this.props.children; 
  }
}

export default ErrorBoundary;